export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vstup:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokračovat"])}
}